var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pending)?_c('Loader'):_c('CompetencesEditor')
}
var staticRenderFns = []

export { render, staticRenderFns }